
import { reactive} from "vue";
import DynamicForm from "@/components/Shared/Dynamicform/DynamicForm.vue";

export default {
  name: "WildBookObserveAnimal",
  inheritAttrs: false,
  components: {
    DynamicForm
  },
  setup() {
    const request = reactive({
      apiLoadMethod: "",
      apiSaveMethod: "api/sync/syncWildbook",
      form: "WildbuchEintragBeobachtung",
      page: "WildbuchEintragTierartBeobachtung",
      remoteId: "",
      
      

    });
    return {
      request
    };
  }
};
